export enum ContactVerificationStatus {
  Skip = 'skip',
  InProgress = 'inProgress',
  Valid = 'valid',
  Risky = 'risky',
  Bad = 'bad',
  Unknown = 'unknown',
}
